<template>
  <v-container fluid>
<v-dialog v-model="dgKolanlarıGoster" scrollable width="700">


                <v-card>
                    <v-card-title class="text-h5 grey lighten-2">
                        Form Verileri
                    </v-card-title>

                    <v-card-text>


                        <!-- <v-list subheader three-line>
                            <v-subheader> {{ result.formname }} Bilgileri</v-subheader>

                            <v-list-item v-for="item in selectedItem.columns" :key="item.ogeId">

                                <v-list-item-content>
                                    <v-list-item-title>{{ item.header }}</v-list-item-title>
                                    <v-list-item-subtitle>

                                        <div v-if="item.tur == 1">
                                            <a target="_blank" :href="`../` + itemLink"
                                                v-for="(itemLink, indexLink) in item.value.split(',')"
                                                :key="itemLink">Dosya_{{
                                                    indexLink }}</a>
                                        </div>
                                        <div v-else>
                                            {{ item.value }}
                                        </div>

                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle v-if="result.onayDurumId == 4">{{ item.reddedilmeNedeni
                                    }}</v-list-item-subtitle>
                                    <v-divider></v-divider>
                                </v-list-item-content>
                            </v-list-item>


                        </v-list> -->

                        <FormViewRun2 :actionVisible="false" :formSavedId="formSavedId" :edit="true">
                        </FormViewRun2>

                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-select v-model="selectedOnayDurumId" :items="onayDurums" item-text="name" item-value="id"
                            label="Onay Durumu" persistent-hint single-line></v-select>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text @click="btnOnaylamaIslemKaydet">
                            Kaydet
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>


    <v-card class="mb-5" outlined>
      <v-card-title class="headline blue-grey lighten-5 primary--text">
        <v-icon left color="primary">mdi-filter-variant</v-icon>
        Form Verileri Filtreleme
      </v-card-title>
      <v-card-text class="pt-4">
        
        <v-form ref="filterForm" @submit.prevent="fetchData">
          <v-row dense>
<v-col cols="12" md="6">
   
               <v-select
          v-model="filters.formIds"
        multiple
          :items="forms"
          item-text="name"
          item-value="id"
          label="Formlar"
          persistent-hint
    
          single-line
        ></v-select>
            </v-col>
            <v-col cols="12" md="5">
              <v-text-field
                v-model="filters.no"
                label="Öğrenci / Personel Numarası"
                outlined
                dense
                prepend-inner-icon="mdi-account-search"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" class="d-flex align-center justify-end">
              <v-btn
                color="primary"
                block
                height="40"
                :loading="loading"
                type="submit"
              >
                <v-icon left>mdi-magnify</v-icon>
                Sorgula
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <v-card  outlined>
      <v-card-title class="d-flex justify-space-between align-center flex-wrap">
        <div>
          <span class="headline font-weight-bold">{{ metaData.formname }}</span>
          <v-chip class="ml-2" small color="secondary" outlined v-if="metaData.groupName">
            Grup: {{ metaData.groupName }}
          </v-chip>
        </div>
        
        <div class="mt-2 mt-sm-0">
          <v-chip :color="metaData.loginGiris ? 'green' : 'grey'" dark small class="mr-1">
            {{ metaData.loginGiris ? 'Giriş Gerekli' : 'Anonim' }}
          </v-chip>
          <v-chip :color="metaData.onaylama ? 'indigo' : 'grey'" dark small>
            {{ metaData.onaylama ? 'Onay Süreçli' : 'Onay Gerekmiyor' }}
          </v-chip>
        </div>
      </v-card-title>

      <v-divider></v-divider>

      <v-data-table
        :headers="headers"
        :items="tableRows"
        :loading="loading"
        loading-text="Veriler yükleniyor... Lütfen bekleyin."
        no-data-text="Kriterlere uygun form kaydı bulunamadı."
        class="elevation-1"
        :footer-props="{
          'items-per-page-options': [10, 25, 50, 100],
          'items-per-page-text': 'Sayfa başına satır:'
        }"
      >
        <template v-slot:item.resim="{ item }">
          <v-avatar size="40" class="my-1">
            <v-img :src="item.resim || 'https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png'">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="grey lighten-5" size="20"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>
        </template>

        <template v-slot:item.username="{ item }">
          <div class="font-weight-medium">{{ item.username2 }}</div>
          <div class="caption text--secondary">{{ item.username || 'Girişsiz Kullanıcı' }}</div>
        </template>
                <template v-slot:item.date="{ item }">
          <div class="font-weight-medium">{{ item.date }}</div>
          <div class="caption text--secondary">{{ item.belongingFormName}}</div>
        </template>

        <template v-slot:item.onayName="{ item }">
          <v-chip :color="getStatusColor(item.OnayDurumId)" dark small>
            {{ item.onayName || 'Beklemede' }}
          </v-chip>
        </template>

        <template v-slot:item.ReddedilmeNedeni="{ item }">
          <span v-if="item.ReddedilmeNedeni" class="red--text text--darken-2 caption">
            {{ item.ReddedilmeNedeni }}
          </span>
          <span v-else class="text--disabled">-</span>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-btn icon small color="blue" @click="viewDetail(item)">
            <v-icon>mdi-eye</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import axios from 'axios'; // API istekleri için axios varsayılmıştır.
import FormService from '@/services/FormService';
import OnayDurumService from '@/services/OnayDurumService';
import FormViewRun2 from '@/components/FormViewRun2.vue';
export default {
  name: 'EbeFormReport',

      components: { FormViewRun2 },
  data() {
    return {
      loading: false,
      dgKolanlarıGoster:false,
      selectedOnayDurumId:null,
      forms:[
{id:"e9d46ae0-5c3b-49fe-b1f5-a7d603a2e407",name:"İNNATAL KRİTER FORMU"},
{id:"b6343296-26b3-4dfd-a641-16d199b69ef7",name:"LOHUSA KRİTER FORMU"},
{id:"b43070f6-c05e-4cc6-8af6-590e963dc8e0",name:"YENİDOĞAN KRİTER FORMU"},
{id:"15f1f7cf-22fb-4c70-8a5c-d76c33fd2400",name:"NORMAL GEBELİK KRİTER FORMU"},
      ],
      formSavedId:null,
      filters: {
        formIds: [], // Örn: 'd3b07384-d113-49cd-a5d6-8ee0315a1a12'
        no: ''      // Öğrenci veya personel numarası
      },
      metaData: {
        formname: '',
        loginGiris: false,
        onaylama: false,
        groupName: ''
      },
      onayDurums:[],
      tableRows: [],
      extraGroupData: [], // Controller'dan dönen "data" listesi (Grup onay raporları)
      headers: [
        { text: 'Profil', value: 'resim', sortable: false, width: '70px' },
        { text: 'Kullanıcı Bilgisi', value: 'username' },
        { text: 'Kayıt Tarihi', value: 'date' },
        { text: 'Durum', value: 'onayName', alignment: 'center' },
        { text: 'Onaylayan', value: 'onaylayanName' },
        { text: 'Red Nedeni', value: 'ReddedilmeNedeni', sortable: false },
        { text: 'İşlemler', value: 'actions', sortable: false, align: 'end' }
      ]
    };
  },
      created() {
        this.dataBind();
    },
  methods: {
    async fetchData() {
      if (!this.$refs.filterForm.validate()) return;

      this.loading = true;
      this.tableRows = [];      // Eski verileri temizle
      this.loadedForms = [];    // Eski form başlıklarını temizle

      try {
        // Seçilen her bir Form ID için sırayla aynı API'ye istek atıyoruz
        for (const id of this.filters.formIds) {
          const response = await axios.get('/api/Form/Data2/'+id, {
            params: {
           
              no: this.filters.no || null
            }
          });

          const resData = response.data;
console.log("resData:",resData);
          if (resData) {
            // Çekilen formun adını üst listeye ekle
            if (resData.formname && !this.loadedForms.includes(resData.formname)) {
              this.loadedForms.push(resData.formname);
            }

            // Gelen satırlara "belongingFormName" (Ait olduğu form adı) mülkünü ekleyip ana listeyle birleştiriyoruz
            if (resData.rows && resData.rows.length > 0) {
              const mappedRows = resData.rows.map(row => ({
                ...row,
                belongingFormName: resData.formname // Tabloda ayırt edebilmek için ekledik
              }));
           
             // this.tableRows.push(...resData.rows);
              this.tableRows.push(...mappedRows);
                console.log("resData2:",this.tableRows);
            }
          }
        }
      } catch (error) {
        console.error("Veriler çekilirken bir hata oluştu:", error);
      } finally {
        this.loading = false;
      }
    },
    // async fetchData() {
    //   if (!this.$refs.filterForm.validate()) return;

    //   this.loading = true;
    //   try {
    //     // Backend API adresinizi buraya göre güncelleyin.
    //     // Örn: /api/Form/Data2
    //     const response = await axios.get('/api/Form/Data2/'+this.filters.formId, {
    //       params: {
          
    //         no: this.filters.no || null
    //       }
    //     });

    //     const resData = response.data;

    //     // Üst bilgileri set edelim
    //     this.metaData = {
    //       formname: resData.formname,
    //       loginGiris: resData.loginGiris,
    //       onaylama: resData.onaylama,
    //       groupName: resData.groupName
    //     };

    //     // Tablo satırlarını set edelim (Backend'deki `rows: list` alanı)
    //     this.tableRows = resData.rows || [];
        
    //     // Eğer gruptan gelen ekstra rapor verileri varsa buraya kaydedilir
    //     this.extraGroupData = resData.data || [];

    //   } catch (error) {
    //     console.error("Veri çekilirken bir hata oluştu:", error);
    //     // Burada kullanıcıya toast/alert ile hata gösterebilirsiniz.
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    // OnayDurumId'ye göre dinamik renk belirleme fonksiyonu
    getStatusColor(statusId) {
      switch (statusId) {
        case 1: return 'warning';  // Beklemede / İşlem Yapılmadı
        case 2: return 'success';  // Onaylandı
        case 3: return 'error';    // Reddedildi
        default: return 'grey';
      }
    },
    viewDetail(item) {
        this.formSavedId=item.formSavedId;
        this.dgKolanlarıGoster=true;
      // Satır detayına tıklandığında yapılacak işlem (Örn: modal açıp formSavedId basmak)
      //alert(`Form Kayıt ID: ${item.formSavedId} detayları başarıyla getirildi.`);
    }
    , 
dataBind(){
    OnayDurumService.listOnayDurums().then((result) => {
                this.onayDurums = result.data;
            }).catch((err) => {

            });
},
        btnOnaylamaIslemKaydet() {

            console.log("this.SElectedItem:", this.selectedItem);
            if (this.selectedOnayDurumId) {
                let reddedilmeNedeni = "";
                //if (this.selectedOnayDurumId==4 ) {
                if ([4, 5].includes(this.selectedOnayDurumId)) {
                    let value = prompt('Reddedilme Nedeni Giriniz',);
                   // console.log("Prompt:", value);
                    if (value == null) {
                        return false;
                    }
                    else {
                        reddedilmeNedeni = value;
                    }

                }

                //this.$toast.warning("Onay Durumu boş bırakılamaz."+value)
                FormService.onaylama(this.formSavedId, { onayDurumId: this.selectedOnayDurumId, onayDurumSebeb: reddedilmeNedeni }).then((result) => {
            
                    this.$toast.success("İşleminiz başarılı bir şekilde gerçekleştirilmiştir.");
                    this.dgKolanlarıGoster = false;
                    this.fetchData();
                }).catch((err) => {

                });
            }
            else {
                this.$toast.warning("Onay Durumu boş bırakılamaz.")
            }

        },
  }
};
</script>

<style scoped>
/* İsteğe bağlı özel CSS düzenlemeleri */
.v-card-title {
  font-size: 1.1rem !important;
}
</style>